import { apiFetch } from "./api";

export interface JobEmailDto {
  jobEmailId: number;
  jobId: number;
  emailLogId: number;
  direction: string;
  subject: string;
  toEmailAddress: string;
  fromEmailAddress: string | null;
  emailKindCode: string;
  sentAtUtc: string;
}

export const jobEmailKeys = {
  thread: (jobId: number) => ["jobs", jobId, "emails"] as const,
};

export const jobEmails = {
  list: (jobId: number) => apiFetch<JobEmailDto[]>(`/api/jobs/${jobId}/emails`),
  send: (jobId: number, body: { toEmailAddress: string; subject: string; htmlBody: string }) =>
    apiFetch<JobEmailDto>(`/api/jobs/${jobId}/emails`, { method: "POST", body: JSON.stringify(body) }),
};
